module.exports = __webpack_public_path__ + "img/rever-isotype-white.952f68be.svg";